<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-3xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4  bg-gradient-to-b from-pitch-purple to-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white">
                                                Create New Commission Invoice
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-indigo-300">
                                                Get started by filling in the information below to create a new invoice.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="space-y-6 pt-6 pb-5">
                                                <div>
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                                                        Invoice Information
                                                    </h3>
                                                </div>
                                                <div class="flex gap-4">
                                                    <div class="w-1/2">
                                                        <label for="reference" class="block text-sm text-gray-900 required">
                                                            Reference
                                                        </label>
                                                        <div class="mt-1">
                                                            <input type="text" id="reference" v-model="form.reference" disabled
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.reference}"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="w-1/2">
                                                        <label for="due_at" class="block text-sm text-gray-900 required">
                                                            Due Date <span v-if="formattedDueDate">({{ formattedDueDate }})</span>
                                                        </label>
                                                        <div class="mt-1">
                                                            <input type="date" id="due_at" v-model="form.due_at"
                                                                   class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                                   :class="{'border-red-500': form.errors.due_at}"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex gap-4">
                                                    <div class="w-1/2">
                                                        <label for="po_reference" class="block text-sm text-gray-900 required">
                                                            Supplier Invoice Reference
                                                        </label>
                                                        <div class="mt-1">
                                                            <input type="text" id="po_reference" v-model="form.po_reference"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.po_reference}"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="w-1/2">
                                                        <label for="amount" class="block text-sm text-gray-900 required">
                                                            Amount
                                                        </label>
                                                        <div class="mt-1">
                                                            <input type="text" id="amount" v-model="form.amount"
                                                                   class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                                   :class="{'border-red-500': form.errors.amount}"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="flex gap-4">
                                                    <div class="flex-grow">
                                                        <label for="ignore_unit4" class="block text-sm text-gray-900">
                                                            Ignore Unit 4 - if this button is ticked then this invoice will not be sent to unit 4. <br />
                                                            These are mainly invoices prior to August 2023. Please check with finance before raising the invoice if you aren't 100% sure.
                                                        </label>
                                                        <div class="mt-1">
                                                            <button type="button" @click="form.ignore_unit4 = !form.ignore_unit4" :class="{'bg-pitch-purple': form.ignore_unit4, 'bg-gray-200': !form.ignore_unit4 }" class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none" role="switch" aria-checked="false">
                                                                <span class="sr-only">Ignore Unit 4</span>
                                                                <span aria-hidden="true" :class="[form.ignore_unit4 ? 'translate-x-5': 'translate-x-0' ]" class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> -->
                                                <div class="flex gap-4">
                                                    <div class="flex-grow">
                                                        <label for="payment_instructions" class="block text-sm text-gray-900">
                                                            Payment Instructions
                                                        </label>
                                                        <div class="mt-1">
                                                            <quill-editor content-type="html" v-model:content="form.payment_instructions"
                                                                :class="{'border-red-500': form.errors.payment_instructions}"
                                                                class="min-h-[150px] mt-1 block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                                theme="snow"></quill-editor>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="flex gap-4">
                                                    <div class="flex-grow">
                                                        <label for="additional_notes" class="block text-sm text-gray-900">
                                                            Additional Notes
                                                        </label>
                                                        <div class="mt-1">
                                                            <quill-editor content-type="html" v-model:content="form.additional_notes"
                                                                :class="{'border-red-500': form.errors.additional_notes}"
                                                                class="min-h-[150px] mt-1 block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                                theme="snow"></quill-editor>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="button"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:bg-gray-200"
                                            @click="previewInvoice()">
                                        <span>Preview</span>
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive, computed} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, QuestionMarkCircleIcon, ExclamationCircleIcon, ArrowCircleRightIcon, RefreshIcon} from '@heroicons/vue/solid'
import {useForm, usePage} from '@inertiajs/vue3'
import { router } from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors";
import moment from 'moment';
import axios from 'axios';
import {emitter} from "@/eventHub";


export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        ExclamationCircleIcon,
        XIcon,
        ArrowCircleRightIcon,
        RefreshIcon
    },
    data() {
        return {
            show: ref(false),
            showErrors: ref(false),
            fixture: computed(() => usePage().props.fixture),
            form: useForm({
                reference: null,
                po_reference: null,
                due_at: null,
                amount: null,
                payment_instructions: null,
                fixture_id: null,
                ignore_unit4: false,
                organisation_id: null,
                quote_service_ids: [],
                additional_notes: null
            })
        }
    },
    created() {
        this.moment = moment
    },
    computed: {
        formattedDueDate() {
            if (this.form.due_at) {
                return moment(this.form.due_at).format('DD MMM YYYY');
            }
            return '';
        },
    },
    methods: {
        submit() {
            this.form.post(route('frontend.fixture.commission.store', [this.fixture.id]), {
                onSuccess: page => {
                    this.show = false;
                    this.showErrors = false;
                    this.form.reset();
                },
                onError: errors => {
                    this.showErrors = true;
                }
            });
        },
        close() {
            this.form.reset();
            this.form.clearErrors();
            this.show = false;
        },
        open() {
            this.form.clearErrors();
            this.show = true;

            // get the invoice config
            this.getConfig();
        },
        /**
         * Get and set the new invoice config
         */
        getConfig() {
            axios.get(route('frontend.fixture.commission.configuration', {fixture: this.fixture.id, quote_service_ids : this.form.quote_service_ids})).then(result => {
                // loop over each key returned from the config json
                for (var key in result.data) {
                    // set it against our new invoice form model
                    this.form[key] = result.data[key];
                }
            });
        },
        /**
         * Previews the invoice
         */
        previewInvoice () {
            axios({
                url: route('frontend.fixture.commission.preview', [this.fixture.id]),
                method: "POST",
                data: this.form,
                responseType: 'arraybuffer'
            }).then(r => {
                const path = window.URL.createObjectURL(new Blob([r.data]));
                const link = document.createElement('a');
                link.href = path;
                link.setAttribute('download', 'DRAFT-' + this.form.reference + '.pdf');
                document.body.appendChild(link);
                link.click(); // force download file
            });
        }
    },
    mounted() {
        emitter.on('openCommissionInvoice', (params) => {
            if (typeof params.fixture !== 'undefined') {
                this.form.fixture_id = params.fixture.id
                this.form.organisation_id = params.organisation_id
                this.form.quote_service_ids = params.quote_services
            }
            this.open();
        });
    }
}
</script>
